import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * Lightweight context that lets Checkout report its current step
 * ("delivery" | "payment") so the slim <MinimalHeader /> can highlight
 * the right progress dot. "cart" is always shown as ✓ once the user is
 * on /checkout since they've just come from the cart page.
 */
const CheckoutStepContext = createContext({
  step: "delivery",
  setStep: () => {},
});

export function CheckoutStepProvider({ children }) {
  const [step, setStep] = useState("delivery");
  const value = useMemo(() => ({ step, setStep }), [step]);
  return (
    <CheckoutStepContext.Provider value={value}>
      {children}
    </CheckoutStepContext.Provider>
  );
}

export function useCheckoutStep() {
  return useContext(CheckoutStepContext);
}
